import { render, staticRenderFns } from "./promotion-item.vue?vue&type=template&id=4321929e&"
import script from "./promotion-item.vue?vue&type=script&lang=js&"
export * from "./promotion-item.vue?vue&type=script&lang=js&"
import style0 from "./promotion-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4321929e')) {
      api.createRecord('4321929e', component.options)
    } else {
      api.reload('4321929e', component.options)
    }
    module.hot.accept("./promotion-item.vue?vue&type=template&id=4321929e&", function () {
      api.rerender('4321929e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/promotion-item.vue"
export default component.exports